<template>
    <v-container class="pt-8 pl-0 footer-address">
        <router-link to="/">
            <img :src="require('../../assets/logo.png')" class="custom-logo" itemprop="logo" />
        </router-link>
        <v-list dense class="transparent" dark>
            <v-list-item class="pl-0">
                <v-list-item-icon class="mr-1">
                    <v-icon color="grey" small>mdi-map-marker</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Českomoravská 2420/15a, Praha 9</v-list-item-title>
            </v-list-item>
            <v-list-item class="pl-0">
                <v-list-item-icon class="mr-1">
                    <v-icon color="grey" small>mdi-phone</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Telefon: +420 724 341 333</v-list-item-title>
            </v-list-item>
            <v-list-item class="pl-0">
                <v-list-item-icon class="mr-1">
                    <v-icon color="grey" small>mdi-mail</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Email: info@riwal.de</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-container>
</template>

<script>
    export default {
        name: 'FooterAddress'
    }
</script>

<style lang="scss">
    .footer-address {
        .custom-logo {
            max-width: 180px;
        }
    }
</style>
